const _excluded = ["className", "style", "intent", "size", "centerBoxHeight", "centerBoxWidth", "centeredInBox", "testId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import cn from 'classnames';
import styles from "./Spinner.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Used to signify a loading state. */
export function Spinner(props) {
  const {
      className,
      style,
      intent = 'default',
      size = 80,
      centerBoxHeight,
      centerBoxWidth,
      centeredInBox,
      testId
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const innerStyle = useMemo(() => ({
    borderWidth: size / 20
  }), [size]);
  const outerStyle = useMemo(() => _objectSpread({
    width: size,
    height: size
  }, style || {}), [size, style]);
  const spinner = /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({}, rest), testId != null ? {
    'data-testid': testId
  } : {}), {}, {
    className: cn(styles.spinner, styles[intent], className),
    style: outerStyle,
    children: [/*#__PURE__*/_jsx("div", {
      style: innerStyle
    }), /*#__PURE__*/_jsx("div", {
      style: innerStyle
    })]
  }));
  return centeredInBox ? /*#__PURE__*/_jsx("div", {
    className: styles.box,
    style: {
      height: centerBoxHeight,
      width: centerBoxWidth
    },
    children: spinner
  }) : spinner;
}